import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { makeKeywordsBold } from '../../data-access/utils/make-bold-keys';
import { UiDialogBtmSheetComponent } from '../ui-components/ui-dialog-btm-sheet/ui-dialog-btm-sheet.component';

@Component({
  selector: 'pay-club-applet-club-rules',
  standalone: true,
  imports: [CommonModule, UiDialogBtmSheetComponent],
  templateUrl: './club-rules.component.html',
  styleUrls: ['./club-rules.component.scss'],
})
export class ClubRulesComponent implements OnInit {
  rules = [
    {
      note: 'پی‌کلاب باشگاه وفاداری کاربران اپلیکیشن دیجی‌پی است که به ازای فعالیت و تراکنش در سرویس‌های دیجی‌پی می توانید پی‌درپی سکه بگیرید و سکه‌هاتو تبدیل به شانس‌ قرعه‌کشی و کدتخفیف کنی. مقدار سکه‌ی همه‌ی فعالیت‌ها و تراکنش‌ها مشخص هستند و به شرط داشتن سکه‌ی کافی می‌توانید هم شانس شرکت در قرعه‌کشی و هم کد تخفیف دریافت کنید.',
      keywords: [],
      htmlRule: '',
    },
    {
      title: 'فعالیت یا تراکنش‌ها و محدودیت آنها:',
      note:
        'با تراکنش در اپلیکیشن دیجی‌پی و انجام فعالیت‌هایی مانند اضافه کردن کارت بانکی ,تکمیل پروفایل و پلاک سکه دریافت می‌کنید.\n' +
        'فعالیت‌ها و تراکنش‌ها دارای محدودیت‌روزانه هستند.\n' +
        'به طور مثال :اگر شما در یک روز ۱۰ تراکنش خرید شارژ داشته باشید به ۵ تراکنش سکه داده می شود پس به محدودیت تعداد توجه کنید.\n',
      keywords: [],
      htmlRule: '',
    },
    {
      title: 'فعالیت‌هاو تراکنش‌هایی  که با آن سکه دریافت می‌کنید:',
      note: '',
      keywords: [],
      items: [
        'افزودن کارت بانکی مبدا: ۲ سکه به ازای هر کارت (حداکثر به ۱۰ کارت در یک روز سکه داده می شود).',
        'افزودن کارت بانکی مقصد:۵ سکه به ازای هر کارت (حداکثر به ۵ کارت در یک روز سکه داده می شود).',
        'افزودن پلاک ماشین: ۵ سکه به ازای هر پلاک (حداکثر به ۲ پلاک در یک روز سکه داده می شود).',
        'تکمیل پروفایل:۵ سکه به ازای هرتغییر در پروفایل (حداکثر به یک تغییر  پروفایل در یک روز سکه داده می شود).',
        'دعوت از دوست با کد معرف شما: ۲۰ سکه به ازای هر دوست (به ازای همه دوستانی که توسط کد معرف شما وارد اپلیکیشن دیجی‌پی شده اند، سکه داده می شود).',
        'خرید بسته اینترنت:۵ سکه به ازای هر تراکنش (حداکثر به ۵ تراکنش در یک روز سکه داده می شود).',
        'خرید شارژسیم‌کارت: ۳ سکه به ازای هر تراکنش (حداکثر به ۵ تراکنش در یک روز سکه داده می شود).',
        'کارت‌به‌کارت:۳ سکه به ازای هر کارت‌به‌کارت (حداکثر به یک کارت‌به‌کارت در یک روز سکه داده می شود).',
        'کمک به خیریه:یک سکه به ازای هر کمک (حداکثر به  ۱۰ کمک  به خیریه در یک روز سکه داده می شود).',
        'استعلام جریمه:۲ سکه به ازای هر استعلام (حداکثر به  ۱۰ کمک  به خیریه در یک روز سکه داده می شود).',
        'پرداخت عوارض‌جاده‌ای:یک سکه به ازای هر عوارض(حداکثر به  ۲ عوارض در یک روز سکه داده می شود).',
        'پرداخت قبض خدماتی (مانند:آب ،برق و...):۲ سکه به ازای هر قبض(حداکثر به  ۱۰ قبض در یک روز سکه داده می شود).',
        'پرداخت قبض تلفن همراه:۲ سکه به ازای هر قبض(حداکثر به  ۱۰ قبض در یک روز سکه داده می شود).',
      ],
      htmlRule: '',
    },
    {
      title: 'روش استفاده از سکه‌ها:',
      note:
        'با سکه‌های خود می توانید از لیست هدایا ،هدیه ی دلخواه خود را دریافت کنید.\n' +
        'با توجه به اینکه سکه‌ی هر قرعه‌کشی و کدتخفیف مشخص هست اگر سکه مورد نیاز آنرا داشته باشید می توانید به دو روش زیر سکه‌هارا تبدیل به هدیه کنید.\n' +
        '۱-قرعه کشی‌ها: شما می توانید با سکه‌های خود شانس شرکت در قرعه کشی دریافت کنیدو برنده جوایز هیجان انگیزی مثل ایفون ,ساعت هوشمند و ...باشید.\n' +
        'در پی‌کلاب دو مدل قرعه کشی داریم:\n' +
        '۱-قرعه‌کشی بامحدودیت شرکت کننده و فرصت ثبت نام : در این نوع قرعه کشی‌ها با توجه به محدود بودن تعداد شرکت‌کنندگان شانس برنده شدن شما بالاتر است.\n' +
        '۲-قرعه کشی بدون محدودیت شرکت کننده: با سکه‌های کمتری می توانید در این نوع قرعه کشی‌ها شرکت کنید.\n' +
        '۲- کدتخفیف: شما می توانید با سکه‌های دریافتی، کدتخفیف برای خدمات دلخواه خود دریافت کنید.\n',
      keywords: ['۱-قرعه کشی‌ها:', '۲- کدتخفیف:'],
      htmlRule: '',
    },
    {
      title: 'تاریخ انقضای سکه‌ها:',
      note: 'سکه‌هاهیج موقع منقضی نمی شوند و می توانید تا هر زمان که خواستید از سکه‌های خود استفاده کنید.',
      keywords: [],
      htmlRule: '',
    },
  ];

  ngOnInit(): void {
    this.generateRulesText();
  }

  generateRulesText(): void {
    this.rules?.forEach((rule) => {
      rule['htmlRule'] = makeKeywordsBold(rule['note'], rule['keywords']);
    });
  }
}
